import type { NodeTypes } from "@xyflow/react";
import { LiteralNode } from "./LiteralNode";
import { FieldNode } from "./FieldNode";
import { ComparisonNode } from "./ComparisonNode";
import { BinaryNode } from "./BinaryNode";
import { UnaryNode } from "./UnaryNode";
import { ExistenceNode } from "./ExistenceNode";
import { MembershipNode } from "./MembershipNode";
import { FunctionNode } from "./FunctionNode";
import { OutputNode } from "./OutputNode";
import { InputNode } from "./InputNode";
import { HubNode } from "./HubNode";
import { EmitOutputNode } from "./EmitOutputNode";
import { TableNode } from "./TableNode";

export const nodeTypes: NodeTypes = {
  literal: LiteralNode,
  field: FieldNode,
  comparison: ComparisonNode,
  binary: BinaryNode,
  unary: UnaryNode,
  existence: ExistenceNode,
  membership: MembershipNode,
  function: FunctionNode,
  output: OutputNode,
  input: InputNode,
  hub: HubNode,
  emitOutput: EmitOutputNode,
  table: TableNode,
};

export {
  LiteralNode,
  FieldNode,
  ComparisonNode,
  BinaryNode,
  UnaryNode,
  ExistenceNode,
  MembershipNode,
  FunctionNode,
  OutputNode,
  InputNode,
  HubNode,
  EmitOutputNode,
  TableNode,
};
